import React from 'react';
import {
  ButtonWithGAClickButton,
  GalleryGrid,
  Section,
  SectionSubTitle,
  Typography,
} from 'common/components';
import { createElementKey } from 'utils';
import { NEW_YEAR_TREE_ELEMENT_BLOCK } from 'landings/new-year-tree/new-year-tree-constants';
import { NYTreeStyleImage } from '../../new-year-tree-types';
import {
  nYtreeStyleButton,
  nYtreeStyleGrid,
  nYtreeStyleImage,
  nYtreeStyleText,
} from './ny-tree-style-styles';

type NYTreeStyleProps = {
  title: string;
  text: string;
  imageList: NYTreeStyleImage[];
  href: string;
  linkTitle: string;
  className?: string;
};

export const NYTreeStyle: React.FC<NYTreeStyleProps> = ({
  title,
  text,
  imageList,
  href,
  linkTitle,
  className,
}) => (
  <Section className={className}>
    <SectionSubTitle margin="s">{title}</SectionSubTitle>
    <Typography adaptive={false} className={nYtreeStyleText} variant="l" size="body_long">
      {text}
    </Typography>
    <GalleryGrid className={nYtreeStyleGrid}>
      {imageList.map((image, index) => (
        <img
          className={nYtreeStyleImage}
          key={createElementKey('ny-tree-image', index)}
          src={image.src}
          alt={image.alt}
          title={image.alt}
          loading="lazy"
        />
      ))}
    </GalleryGrid>
    <ButtonWithGAClickButton
      className={nYtreeStyleButton}
      rounded
      adaptive={false}
      elementBlock={NEW_YEAR_TREE_ELEMENT_BLOCK}
      elementText="Смотреть все товары стиля"
      elementName={title}
      href={href}
      title={linkTitle}>
      Смотреть все товары стиля
    </ButtonWithGAClickButton>
  </Section>
);
